import 'whatwg-fetch'
import { ElNotification } from 'element-plus'

interface ResponseError extends Error {
  response: any;
}

// 请求函数
export function myFetch(url = '', data = {}, config?: any): Promise<any> {
  const params: RequestInit = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    redirect: 'follow',
    ...config
  }
  if (!config || !config.method || config.method === 'POST') {
    params.body = JSON.stringify(data)
  }
  return fetch(url, params).then((response) => {
    if (response.status >= 200 && response.status < 300) {
      return response
    } else {
      const error: ResponseError = new Error(response.statusText) as ResponseError
      error.response = response
      ElNotification.error(error.response || '网络异常')
      // Notification.error('网络异常');
      throw error
    }
  }).then((response) => {
    return response.json()
  })
}